import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { CircularProgress, Snackbar, Alert, Button } from '@mui/material';
import { AccountTree, Speed, QuestionMark, Check } from '@mui/icons-material';

import useErrorManager from "../../hooks/useErrorManager";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import PageContainer from '../Layout/PageContainer';
import GenericTable from '../Layout/Table/GenericTable';
import TextFilter from "../Layout/Table/TextFilter"
import TextLinkButton from "../Layout/TextLinkButton"

import { useNotification } from '../../contexts/NotificationContext';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext'; // Import breadcrumb context

function Gateways() {
    const [gateways, setGateways] = useState([]);
    const [filterText, setFilterText] = useState("");

    const [loading, setLoading] = useState(true);

    const { setError, clearError, getError } = useErrorManager();
    const { showNotification } = useNotification();
    const { updateBreadcrumb } = useBreadcrumb(); // Use breadcrumb context to update breadcrumb

    const navigate = useNavigate();
    const axiosInstance = useAxiosPrivate();


    const columns = [
        { id: 'name', label: 'Name', filtered: true, render: (item) => <TextLinkButton action={() =>handleGatewaySelect(item.id)} text={item.name}/>},

        // { id: 'name', label: 'Name', filtered: true, render: (item) => <Button onClick={() => handleGatewaySelect(item.id)}>{item.name}</Button> },
        {
            id: 'type',
            label: 'Type',
            filtered: true,
            filterValue: (item) => item.qnodeSupport ? 'QNode' : 'DM',
            sortValue: (item) => (item.qnodeSupport ? 1 : item.dmSupport ? 2 : 3),
            render: (item) => renderGatewayIcon(item.qnodeSupport, item.dmSupport)
        },
        {
            id: 'location',
            label: 'Location',
            filtered: true,
            filterValue: (item) => item.locationDetails?.name,
            sortValue: (item) => item.locationDetails?.name?.toLowerCase(),
            render: (item) => item.locationDetails?.name
        },
        { id: 'created', label: 'created', filtered: true },
        { id: 'serial', label: 'Serial', filtered: true },
        { id: 'handledNetworkCnt', label: 'Networks' },
        { id: 'dmReadoutConfigured', label: 'DM Readouts', render: (item)  => item.dmReadoutConfigured ? <Check/> : "" }
    ];


    useEffect(() => {
        const fetchGateways = async () => {
            try {
                const response = await axiosInstance.get('/gateways/list', {
                    withCredentials: true,
                });
                setGateways(response.data);
                clearError('fetch');
                setLoading(false);

            } catch (error) {
                setError('fetch', error.message);
                showNotification('Failed to fetch gateways','error')
                setLoading(false);
            }
        };

        updateBreadcrumb([
            { label: 'Manage Gateways'}
        ]);

        fetchGateways();
    }, []);
    
    const renderGatewayIcon = (qnode, dm) => {
        if (qnode === dm) {
            return (<QuestionMark/>);
        } else if (qnode) {
            return (<AccountTree/>);
        } else {
            return (<Speed/>);
        }
    };

    const handleGatewaySelect = async (gatewayId) => {
        navigate(`/gateways/${gatewayId}`);
    };


    const handleFilterChange = (event) => {
        setFilterText(event.target.value);
    };

    return (
            <PageContainer>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <>
                        <TextFilter
                            columns={columns}
                            onFilterChange={handleFilterChange}
                        />
                        <GenericTable
                            items={gateways}
                            columns={columns}
                            filterText={filterText}
                        />
                    </>
                )}
            </PageContainer>
    );
}

export default Gateways;